export const INTERN_STATUSES = {
  pending_video: { label: 'Pending Video', color: '#ed6c02' },
  pending_assessment: { label: 'Pending Assessment', color: '#2563eb' },
  pending_referral: { label: 'Pending Referral', color: '#7c3aed' },
  pending_review: { label: 'Pending Review', color: '#d97706' },
  approved: { label: 'Approved', color: '#16a34a' },
  rejected: { label: 'Rejected', color: '#dc2626' },
  suspended: { label: 'Suspended', color: '#6b7280' },
};

export const BOOKING_STATUSES = {
  pending: { label: 'Pending', color: '#ed6c02' },
  confirmed: { label: 'Confirmed', color: '#16a34a' },
  in_progress: { label: 'In Progress', color: '#2563eb' },
  pending_report: { label: 'Awaiting Mentor Review', color: '#7c3aed' },
  needs_revision: { label: 'Revision Requested', color: '#dc2626' },
  completed: { label: 'Completed', color: '#0d9488' },
  cancelled: { label: 'Cancelled', color: '#dc2626' },
  expired: { label: 'Expired', color: '#6b7280' },
  intern_no_show: { label: 'Intern No-Show', color: '#dc2626' },
  client_no_show: { label: 'Client No-Show', color: '#dc2626' },
  needs_admin_attention: { label: 'Needs Attention', color: '#dc2626' },
  refunded: { label: 'Refunded', color: '#6b7280' },
  partially_refunded: { label: 'Partially Refunded', color: '#9333ea' },
};

export const ASSESSMENT_STATUSES = {
  scheduled: { label: 'Scheduled', color: '#2563eb' },
  in_progress: { label: 'In Progress', color: '#ed6c02' },
  pending_review: { label: 'Pending Review', color: '#d97706' },
  under_review: { label: 'Under Review', color: '#7c3aed' },
  approved: { label: 'Approved', color: '#16a34a' },
  revision_needed: { label: 'Revision Needed', color: '#dc2626' },
  completed: { label: 'Completed', color: '#0d9488' },
};

// Video review status — maps the video_status field on intern records.
// 'pending' = uploaded, awaiting mentor review.
// 'approved' = reviewed and accepted.
// 'rejected' = reviewed and sent back; intern can re-upload.
// 'none'    = synthetic value the frontend uses when video_url is missing.
export const VIDEO_STATUSES = {
  pending: { label: 'Pending review', color: '#d97706' },
  approved: { label: 'Approved', color: '#16a34a' },
  rejected: { label: 'Rejected', color: '#dc2626' },
  none: { label: 'No video', color: '#6b7280' },
};

export const SIDEBAR_WIDTH = 260;

export const COGNITO_CONFIG = {
  UserPoolId: 'us-east-1_BgiyvRzCN',
  ClientId: '6jh0pek0fjvel7fdlhrimkm9mn',
};
